<template>
  <div class="landing-page-container">
    <div class="">
      <div class="panel panel-default landing-page">
        <div class="landing-page-div">

        
          <section>
            <div class="container" >
              <b-row>
                <b-col lg="12" md="12" sm="12" xs="12">
                  <div style="margin-top:200px;margin-bottom:200px">
                    <h3><b>{{langDec['products'] }}</b></h3>
                  </div>
                </b-col>
              </b-row>
            </div>
          </section>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../store/index.js"
  export default {
    name: 'Home',
    data() {
      return {
        aboutUsShowMore: false,

        // slide
        slide: 0,
        sliding: null,
        langDec: {}
      }
    },
    methods: {

      // slide
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },


      goToLogin() {
        this.$router.push({
          name: "login"
        })
      },
      goToRoute(name) {
        this.$router.push({
          name
        })
      }
    },
    created() {
      this.langDec = store.getters.getLangData
    }
  }
</script>
